import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
const images = ["Rectangle 78.png", "Rectangle 79.png", "Rectangle 80.png"];

const OurWork = () => {
  const [current, setCurrent] = useState(0);

  const handleNext = () => setCurrent((prev) => (prev + 1) % images.length);
  const handlePrev = () =>
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));

  return (
    <div className="w-full flex flex-col items-center font-roboto bg-white mt-10 p-4 sm:p-6 lg:p-10">
      {/* Section Heading */}
      <section id="Work" className="flex flex-col items-center text-center">
        <span className="text-white bg-[#B20925] px-6 py-1 rounded-lg mb-4">
          Our Work
        </span>
        <h1 className="text-3xl sm:text-5xl font-bold">What We Create</h1>
        <p className="text-[#A3A3A3] font-medium mt-4 max-w-2xl">
          Explore the projects where creativity meets technology — designed to
          inspire, scale, and succeed.
        </p>
      </section>

      {/* Image Carousel */}
      <div className="relative w-full flex flex-col items-center justify-center mt-10">
        <div className="relative w-full max-w-4xl h-[400px] flex justify-center items-center overflow-hidden rounded-2xl shadow-lg border border-gray-200">
          {images.map((src, index) => {
            const position = (index - current + images.length) % images.length;
            return (
              <img
                key={src}
                src={src}
                alt=""
                className={`absolute object-contain rounded-xl transition-all duration-500 ease-in-out
                ${
                  position === 0
                    ? "opacity-100 scale-100 z-30"
                    : position === 1
                    ? "opacity-70 scale-90 translate-x-1/3 z-20 blur-sm"
                    : position === 2
                    ? "opacity-50 scale-80 translate-x-2/3 z-10 blur-md"
                    : "hidden"
                }`}
              />
            );
          })}
        </div>

        {/* Text + Buttons */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-4 mt-10">
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <h2 className="text-2xl sm:text-4xl font-semibold text-[#434040]">
              Job Finding Website Design
            </h2>

            <div className="flex flex-wrap justify-center sm:justify-start gap-3 mt-4">
              <div className="flex items-center border border-[#B20925] px-4 py-1 rounded-2xl shadow-lg">
                <span className="text-[#B20925] font-semibold">SaaS Website</span>
              </div>
              <div className="flex items-center border border-[#B20925] px-4 py-1 rounded-2xl shadow-lg">
                <span className="text-[#B20925] font-semibold">Landing Page</span>
              </div>
            </div>

            <a className="mt-6 bg-[#B20925] text-white rounded-3xl px-6 py-3 border-2 border-white ring ring-white ring-offset-2 ring-offset-[#B20925] hover:scale-105 transition-all"
                  href="https://acadimyst.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleNext}
            >
              View Project
            </a>
          </div>

          {/* Navigation Arrows */}
          <div className="flex justify-center sm:justify-start gap-6 mt-6 sm:mt-0">
            <button
              onClick={handlePrev}
              className="rounded-full w-12 h-12 bg-[#B20925] flex justify-center items-center border-2 border-white ring ring-white ring-offset-2 ring-offset-[#B20925]"
            >
              <img src="Left Arrow.png" alt="Left Arrow" className="w-6 h-6" />
            </button>
            <button
              onClick={handleNext}
              className="rounded-full w-12 h-12 bg-[#B20925] flex justify-center items-center border-2 border-white ring ring-white ring-offset-2 ring-offset-[#B20925]"
            >
              <img src="Right Arrow.png" alt="Right Arrow" className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurWork;
